import React from "react";
import styled from "styled-components";
import Contact from "./Contact";
import Social from "./Social";

const Footer = () => {
	return (
		<div
			data-aos="fade-up"
			data-aos-offset="100"
			data-aos-delay="50"
			data-aos-duration="1200"
			data-aos-easing="ease-in"
			data-aos-once="true"
		>
			<Contact />

			<Social />

			<StyledDiv>
				<div>
					<img src="./images/sharingan.svg" alt="" />{" "}
					<div className="profile-name">
						<div>
							Designed by Ekene and Developed by
							<a
								href="https://personal-website-alpha-azure.vercel.app/"
								target="_blank"
								rel="noreferrer"
								className="ebube"
							>
								Ebube
							</a>
							.
							<img
								src="./images/cursor1.svg"
								alt=""
								className="image-cursor"
							/>
						</div>
					</div>
				</div>
			</StyledDiv>
		</div>
	);
};

export default Footer;

const StyledDiv = styled.div`
	margin: 32px 0;
	padding-bottom: 72px;

	& > div {
		max-width: 500px;
		margin: 0 auto;
		display: flex;
		align-items: center;
		img {
			width: 100px;
		}
	}

	.profile-name {
		display: flex;

		div {
			position: relative;
			flex-wrap: wrap;
		}

		.image-cursor {
			width: 30px;
			position: absolute;
			bottom: -14px;
			left: 65px;
			@media (min-width: 415px) {
				position: absolute;

				bottom: -20px;
				left: 66px;
			}
			@media (min-width: 550px) {
				position: absolute;
				bottom: -20px;
				left: 325px;
			}
		}
	}

	.ebube {
		display: inline;
		padding-left: 4px;
	}
`;
